var $ = require('jquery');

// Expand or collapse a single .accordion-item and keep its ARIA state in sync.
function setExpanded($item, expanded) {
	$item.find('> .accordion-title > .accordion-trigger').attr(
		'aria-expanded',
		expanded ? 'true' : 'false'
	);
	$item.find('> .accordion-content').prop('hidden', !expanded);
}

module.exports = {
	init: function () {
		$(document).on('click', '.accordion-item .accordion-trigger', function () {
			var $trigger = $(this);
			var $item = $trigger.closest('.accordion-item');
			var isExpanded = $trigger.attr('aria-expanded') === 'true';
			var group = $item.attr('data-accordion-group');

			// Only one panel in a group may be open at a time.
			if (!isExpanded && group) {
				$('.accordion-item[data-accordion-group="' + group + '"]')
					.not($item)
					.each(function () {
						setExpanded($(this), false);
					});
			}

			setExpanded($item, !isExpanded);
		});
	},
};
